import React from 'react';
import createSvgIcon from '../../../shared/utils/create-svg-icon';
import { ReactComponent as Icon } from '../../../assets/icon-bin.svg';

export const BinIcon = createSvgIcon(<Icon />, 'BinIcon');
